import {React} from 'common'
import ReactPlayer from 'react-player'
import {useDispatch} from 'react-redux'
import {setCurrentMediaPlaying, useCurrentMediaPlaying} from 'store/Store'
import styled from 'styled-components'

const MediaPlayer = ({url, isSong}) => {
    const dispatch = useDispatch()
    const currentlyPlaying = useCurrentMediaPlaying()

    const canPlay = ReactPlayer.canPlay(url)
    const doDisplayPlayer = !!canPlay

    if (!doDisplayPlayer) {
        return <></>
    }

    const setToPlaying = () => dispatch(setCurrentMediaPlaying(url))

    return (
        <Container isSong={isSong}>
            <ReactPlayer
                controls={true}
                onStart={setToPlaying}
                onPlay={setToPlaying}
                playing={url === currentlyPlaying}
                width="100%"
                height={isSong ? '60px' : '160px'}
                style={{
                    borderRadius: '12px',
                    overflow: 'hidden',
                }}
                url={url}
            />
        </Container>
    )
}

export default MediaPlayer

const Container = styled.div``
